import { observer } from 'mobx-react-lite';
import { FC, MutableRefObject } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { OnboardingPopover } from '@gem/ui-kit';

import { OnboardingType } from 'APP/constants/onboarding';
import { useOnboardingManager } from 'APP/main/hooks/onboardingManager/useOnboardingManager';

import styles from './styles.m.css';

interface ScheduleOnboardingProps {
  reference: MutableRefObject<HTMLButtonElement | null>;
}

export const ScheduleOnboarding: FC<ScheduleOnboardingProps> = observer(({ reference }) => {
  const { t } = useTranslation();
  const presenter = useOnboardingManager(OnboardingType.ScheduleMessage);

  if (!presenter.isNeedToShow) {
    return null;
  }

  return (
    <OnboardingPopover
      className={styles.container}
      reference={reference}
      description={t('onboarding_postponed_sending_web')}
      isOpened={presenter.isOpened}
      handleClose={presenter.handleClose}
    />
  );
});
